import React, { memo, useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { Loading } from 'app/components/Loading/Loading';
import { useInjectReducer } from 'utils/redux-injectors';

import { selectInit } from './selectors';
import { actions, reducer, sliceKey } from './slice';

interface Props {
  children: React.ReactNode;
}

export const Auth = memo((props: Props) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  const [requested, setRequested] = useState(false);

  const dispatch = useDispatch();
  const init = useSelector(selectInit);

  useEffect(() => {
    const handlerReceiveToken = event => {
      if (typeof event.data == 'object' && event.data.func === 'sendToken') {
        if (!!event.data.config && !requested) {
          dispatch(
            actions.updateInit({
              npi: event.data.config.npi,
              providerId: event.data.config.providerId,
              utm: event.data.config.utm,
            }),
          );
          setRequested(true);
        }
      }
    };
    window.addEventListener('message', handlerReceiveToken, false);

    try {
      window.parent.postMessage({ func: 'ready' }, '*');
    } catch (_) {}

    return () => {
      window.removeEventListener('message', handlerReceiveToken, false);
    };
  });

  if (!!init.loading) {
    return <Loading />;
  }

  return <>{props.children}</>;
});
